import { useState, useEffect, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Badge } from 'react-bootstrap';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import { buscarDashboard } from '../../actions/dashboard';

const DashboardCliente = () => {

    const dispatch = useDispatch();

    const { detalles } = useSelector(state => state.dashboard);
    const { usuario } = useSelector(state => state.auth);

    const [indicadores, setIndicadores] = useState({ pendientes: null, realizadas: null, canceladas: null });
    const [proximasCitas, setProximasCitas] = useState([]);
    const [membresiaActual, setMembresiaActual] = useState(null);
    const [resumenPaquetes, setResumenPaquetes] = useState({ total_paquetes: null, citas_totales: null, citas_disponibles: null });

    const formatFecha = (iso) => {
        const d = new Date(iso);
        return d.toLocaleDateString('es-MX', { weekday: 'short', day: 'numeric', month: 'short' });
    }

    const formatHora = (iso) => {
        return new Date(iso).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
    }

    const statusMembresia = (status) => {
        switch(status){
            case 0: return { label: 'Activa', bg: 'success' };
            case 1: return { label: 'Vencida', bg: 'warning' };
            case 2: return { label: 'Cancelada', bg: 'danger' };
            default: return { label: 'Sin definir', bg: 'secondary' };
        }
    }

    useEffect(() => {
        dispatch(buscarDashboard('cliente'));
    }, []);

    useEffect(() => {
        if(detalles){
            setIndicadores(detalles.indicadores || { pendientes: 0, realizadas: 0, canceladas: 0 });
            setProximasCitas(detalles.proximas_citas || []);
            setMembresiaActual(detalles.membresia_actual || null);
            setResumenPaquetes(detalles.resumen_paquetes || { total_paquetes: 0, citas_totales: 0, citas_disponibles: 0 });
        }
    }, [detalles]);

    return (
        <Fragment>
            <HelmetProvider>
                <Helmet>
                    <style>{`
                        .dash-greeting {
                            background: linear-gradient(135deg, #0f0d07 0%, #32220b 100%);
                            border-radius: 16px;
                            padding: 28px 32px;
                            color: #fff;
                            margin-bottom: 8px;
                            border: 1px solid rgba(145, 122, 90, 0.25);
                        }

                        .dash-greeting h4 {
                            font-size: 1.5rem;
                            font-weight: 700;
                            margin: 0 0 4px 0;
                            font-family: "Playfair Display", serif;
                            color: #fff;
                        }

                        .dash-greeting p {
                            margin: 0;
                            opacity: 0.65;
                            font-size: 0.88rem;
                            color: #e9d0b0;
                        }

                        .kpi-card {
                            border-radius: 14px;
                            padding: 22px 24px;
                            color: #fff;
                            position: relative;
                            overflow: hidden;
                            height: 100%;
                        }

                        .kpi-card .kpi-icon {
                            font-size: 2.8rem;
                            opacity: 0.15;
                            position: absolute;
                            right: 18px;
                            bottom: 10px;
                        }

                        .kpi-card .kpi-number {
                            font-size: 2.4rem;
                            font-weight: 800;
                            line-height: 1;
                            margin: 0 0 6px 0;
                            font-family: "Playfair Display", serif;
                        }

                        .kpi-card .kpi-label {
                            font-size: 0.78rem;
                            font-weight: 600;
                            text-transform: uppercase;
                            letter-spacing: 0.07em;
                            opacity: 0.88;
                            margin: 0;
                        }

                        .kpi-pendientes { background: linear-gradient(135deg, #917a5a 0%, #6b5a3e 100%); }
                        .kpi-realizadas { background: linear-gradient(135deg, #4a7059 0%, #2e4d3b 100%); }
                        .kpi-canceladas { background: linear-gradient(135deg, #8b3a2a 0%, #5c2218 100%); }

                        .dash-card {
                            border: 1px solid rgba(145, 122, 90, 0.15);
                            border-radius: 14px;
                            box-shadow: 0 2px 14px rgba(50, 34, 11, 0.06);
                            height: 100%;
                            background: #ffffff;
                        }

                        .dash-card .card-header {
                            background: linear-gradient(135deg, #faf8f5, #f5f0e8);
                            border-bottom: 1px solid rgba(145, 122, 90, 0.2);
                            padding: 16px 22px 13px;
                            font-weight: 700;
                            font-size: 0.92rem;
                            color: #32220b;
                            letter-spacing: 0.01em;
                            font-family: "Playfair Display", serif;
                            border-radius: 14px 14px 0 0;
                        }

                        .dash-card .card-header i {
                            margin-right: 8px;
                            color: #917a5a;
                        }

                        .dash-card .card-body {
                            padding: 18px 22px;
                        }

                        .cita-item {
                            display: flex;
                            align-items: flex-start;
                            gap: 14px;
                            padding: 12px 0;
                            border-bottom: 1px solid #f5f5f5;
                        }

                        .cita-item:last-child {
                            border-bottom: none;
                            padding-bottom: 0;
                        }

                        .cita-fecha-badge {
                            background: linear-gradient(135deg, #f5f0e8, #ede5d4);
                            border-radius: 10px;
                            min-width: 58px;
                            text-align: center;
                            padding: 8px 6px;
                            flex-shrink: 0;
                            border: 1px solid rgba(145, 122, 90, 0.2);
                        }

                        .cita-fecha-badge .dia {
                            font-size: 1.5rem;
                            font-weight: 800;
                            color: #32220b;
                            line-height: 1;
                            font-family: "Playfair Display", serif;
                        }

                        .cita-fecha-badge .mes {
                            font-size: 0.7rem;
                            text-transform: uppercase;
                            color: #917a5a;
                            font-weight: 600;
                        }

                        .cita-info .servicio {
                            font-weight: 600;
                            color: #32220b;
                            font-size: 0.92rem;
                            margin: 0 0 2px 0;
                        }

                        .cita-info .locatario {
                            font-size: 0.8rem;
                            color: #6b7280;
                            margin: 0 0 3px 0;
                        }

                        .cita-info .hora {
                            font-size: 0.78rem;
                            color: #9ca3af;
                            margin: 0;
                        }

                        .membresia-nombre {
                            font-size: 1.15rem;
                            font-weight: 700;
                            color: #32220b;
                            margin: 0 0 6px 0;
                            font-family: "Playfair Display", serif;
                        }

                        .beneficio-item {
                            display: flex;
                            align-items: flex-start;
                            gap: 8px;
                            padding: 6px 0;
                            font-size: 0.87rem;
                            color: #32220b;
                            border-bottom: 1px solid rgba(145, 122, 90, 0.12);
                        }

                        .beneficio-item:last-child {
                            border-bottom: none;
                        }

                        .beneficio-item i {
                            color: #917a5a;
                            margin-top: 1px;
                            flex-shrink: 0;
                        }

                        .resumen-stat {
                            text-align: center;
                            padding: 18px 10px;
                        }

                        .resumen-stat .stat-number {
                            font-size: 2rem;
                            font-weight: 800;
                            color: #32220b;
                            line-height: 1;
                            margin: 0 0 4px 0;
                            font-family: "Playfair Display", serif;
                        }

                        .resumen-stat .stat-label {
                            font-size: 0.75rem;
                            text-transform: uppercase;
                            letter-spacing: 0.07em;
                            color: #917a5a;
                            font-weight: 600;
                            margin: 0;
                        }

                        .resumen-divider {
                            border-left: 1px solid rgba(145, 122, 90, 0.2);
                        }

                        .sin-datos {
                            text-align: center;
                            color: #b8a48a;
                            font-size: 0.88rem;
                            padding: 24px 0;
                        }

                        .sin-datos i {
                            font-size: 2rem;
                            display: block;
                            margin-bottom: 8px;
                            color: #d4c4a8;
                        }

                        .membresia-sin {
                            text-align: center;
                            padding: 24px 0;
                        }

                        .membresia-sin i {
                            font-size: 2.5rem;
                            color: #d4c4a8;
                            display: block;
                            margin-bottom: 10px;
                        }

                        .membresia-sin p {
                            color: #b8a48a;
                            font-size: 0.88rem;
                            margin: 0;
                        }
                    `}</style>
                </Helmet>
            </HelmetProvider>

            {/* Saludo */}
            <div className="col-md-12 mb-4">
                <div className="dash-greeting">
                    <h4>¡Hola, {usuario?.nombre} {usuario?.apellido_paterno}!</h4>
                    <p>
                        {new Date().toLocaleDateString('es-MX', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
                    </p>
                </div>
            </div>

            {/* KPI cards */}
            <div className="col-md-4 mb-4">
                <div className="kpi-card kpi-pendientes">
                    <p className="kpi-number">{indicadores.pendientes ?? '-'}</p>
                    <p className="kpi-label">Citas pendientes</p>
                    <i className="fas fa-clock kpi-icon"></i>
                </div>
            </div>

            <div className="col-md-4 mb-4">
                <div className="kpi-card kpi-realizadas">
                    <p className="kpi-number">{indicadores.realizadas ?? '-'}</p>
                    <p className="kpi-label">Citas realizadas</p>
                    <i className="fas fa-check-circle kpi-icon"></i>
                </div>
            </div>

            <div className="col-md-4 mb-4">
                <div className="kpi-card kpi-canceladas">
                    <p className="kpi-number">{indicadores.canceladas ?? '-'}</p>
                    <p className="kpi-label">Citas canceladas</p>
                    <i className="fas fa-times-circle kpi-icon"></i>
                </div>
            </div>

            {/* Próximas citas + Membresía */}
            <div className="col-md-7 mb-4">
                <div className="card dash-card">
                    <div className="card-header">
                        <i className="fas fa-calendar-alt"></i> Próximas citas
                    </div>
                    <div className="card-body">
                        {
                            proximasCitas.length > 0 ?
                                proximasCitas.map((cita) => {
                                    const fecha = new Date(cita.fecha_inicio);
                                    return (
                                        <div className="cita-item" key={cita._id}>
                                            <div className="cita-fecha-badge">
                                                <div className="dia">{fecha.getDate()}</div>
                                                <div className="mes">{fecha.toLocaleDateString('es-MX', { month: 'short' })}</div>
                                            </div>
                                            <div className="cita-info flex-grow-1">
                                                <p className="servicio">{cita.servicio?.nombre || 'Sin servicio'}</p>
                                                <p className="locatario"><i className="fas fa-map-marker-alt fa-xs me-1"></i>{cita.locatario?.nombre || 'Sin locatario'}</p>
                                                <p className="hora"><i className="fas fa-clock fa-xs me-1"></i>{formatHora(cita.fecha_inicio)} — {formatHora(cita.fecha_fin)}</p>
                                            </div>
                                            {
                                                cita.paquete ?
                                                    <div className="align-self-center">
                                                        <Badge bg="primary" style={{ fontSize: '0.7rem' }}>Paquete</Badge>
                                                    </div>
                                                :
                                                    null
                                            }
                                        </div>
                                    );
                                })
                            :
                                <div className="sin-datos">
                                    <i className="fas fa-calendar-times"></i>
                                    No tienes citas próximas
                                </div>
                        }
                    </div>
                </div>
            </div>

            <div className="col-md-5 mb-4">
                <div className="card dash-card">
                    <div className="card-header">
                        <i className="fas fa-id-card"></i> Membresía actual
                    </div>
                    <div className="card-body">
                        {
                            membresiaActual ?
                                <>
                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                        <p className="membresia-nombre">{membresiaActual.nombre}</p>
                                        <Badge bg={statusMembresia(membresiaActual.status).bg}>
                                            {statusMembresia(membresiaActual.status).label}
                                        </Badge>
                                    </div>
                                    <div>
                                        {
                                            membresiaActual.beneficios?.length > 0 ?
                                                membresiaActual.beneficios.map((beneficio, index) => (
                                                    <div className="beneficio-item" key={index}>
                                                        <i className="fas fa-check-circle fa-sm"></i>
                                                        <span>{beneficio}</span>
                                                    </div>
                                                ))
                                            :
                                                <p className="text-muted" style={{ fontSize: '0.88rem' }}>Sin beneficios registrados</p>
                                        }
                                    </div>
                                </>
                            :
                                <div className="membresia-sin">
                                    <i className="fas fa-id-card-alt"></i>
                                    <p>No cuentas con una membresía activa</p>
                                </div>
                        }
                    </div>
                </div>
            </div>

            {/* Resumen de paquetes */}
            <div className="col-md-12 mb-4">
                <div className="card dash-card">
                    <div className="card-header">
                        <i className="fas fa-box-open"></i> Resumen de paquetes
                    </div>
                    <div className="card-body p-0">
                        <div className="row g-0">
                            <div className="col-md-4">
                                <div className="resumen-stat">
                                    <p className="stat-number">{resumenPaquetes.total_paquetes ?? '-'}</p>
                                    <p className="stat-label">Paquetes contratados</p>
                                </div>
                            </div>
                            <div className="col-md-4 resumen-divider">
                                <div className="resumen-stat">
                                    <p className="stat-number">{resumenPaquetes.citas_totales ?? '-'}</p>
                                    <p className="stat-label">Citas totales</p>
                                </div>
                            </div>
                            <div className="col-md-4 resumen-divider">
                                <div className="resumen-stat">
                                    <p className="stat-number" style={{ color: resumenPaquetes.citas_disponibles > 0 ? '#4a7059' : '#8b3a2a' }}>
                                        {resumenPaquetes.citas_disponibles ?? '-'}
                                    </p>
                                    <p className="stat-label">Citas disponibles</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default DashboardCliente;
